<template>
  <el-dialog
    :title="$locale('global.applicableTheater')"
    class="egl-dialog-elm pdf-dialog"
    :visible="visible"
    :show-close="true"
    @close="cancelAction"
    :close-on-click-modal="false"
  >
    <el-form class="egl-elm egl-detail" label-position="top">
      <el-form-item :label="$locale('global.applicableTheater') + $locale('form.plsSelect')">
        <div class="approve_cinemas" v-show="adminType === 'brand'">
          <el-checkbox
            v-model="approveCinemas.all"
            :key="approveCinemas.all"
            :label="approveCinemas.all"
            @change="selectApproveCinema"
          >{{ $locale("global.all") }}</el-checkbox>
          <el-checkbox-group
            v-model="approveCinemas.cinemas"
          >
            <el-checkbox
              v-for="item in cinemaList"
              :key="item.id"
              :label="item.id "
              :disabled="approveCinemas.all"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="egl-btn-white" @click="cancelAction">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="confirmAction">{{ $locale("global.approve") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "approve-dialog",
  props: {
    formData: {
      required: true,
      type: Object,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    approveCinemas: {
      type: Object,
      required: true,
    },
    cinemaList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      adminType: window.localStorage.getItem("adminType"),

    };
  },
  methods: {
    cancelAction() {
      this.$emit("closeDialogAction");
    },
    selectApproveCinema() {
      this.approveCinemas.cinemas = [];
    },
    confirmAction() {
      let confirmHtml = `<i class="egl-confirm-question"></i><span class="result-text">「${this.formData.name}」${this.$locale("movie.sureToCreate")}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-btn-white",
        closeOnClickModal: false,
      })
        .then(() => {
          let ids = [];
          this.cinemaList.forEach(item => {
            ids.push(item.id);
          });

          let id = "";
          if (this.approveCinemas.all) {
            id = ids;
          } else {
            id = this.approveCinemas.cinemas;
          }
          this.$emit("saveFormAction", id);
          this.$emit("closeDialogAction");
        });
    },
  },
};
</script>